<template>
  <div style="margin-top: 113px">
    <v-container>
      <v-card>
        <v-snackbar
          v-model="snackbar"
          :color="snackBarColor"
          :timeout="snackBarTimeout"
        >
          <b>{{ snackBarText }} </b>
        </v-snackbar>
        <v-card-title>
          <h3 v-if="!hasRoleSuperAdmin()">
            Company
          </h3>
          <div class="my-2" v-if="hasRoleSuperAdmin()">
            <div v-if="$route.params.typeRef != 'labels'">
              <v-btn
                small
                class="mx-2"
                fab
                dark
                color="warning"
                v-on:click="$router.go(-1)"
              >
                <v-icon dark>mdi-arrow-left</v-icon>
              </v-btn>
              <v-btn
                small
                class="mx-2"
                fab
                dark
                color="primary"
                v-on:click="addNew"
              >
                <v-icon dark>mdi-plus</v-icon>
              </v-btn>
            </div>
            <div v-else>
              <v-btn
                small
                class="mx-2"
                fab
                dark
                color="warning"
                v-on:click="$router.go(-1)"
              >
                <v-icon dark>mdi-arrow-left</v-icon>
              </v-btn>
            </div>
          </div>
        </v-card-title>
        <v-card-text>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left" style="width: 25%">Code</th>
                  <th class="text-left" style="width: 25%">Label</th>
                  <th
                    v-if="$route.params.typeRef == 'companies'"
                    class="text-left"
                    style="width: 25%"
                  >
                    HR referent
                  </th>
                  <th
                    v-if="$route.params.typeRef == 'companies'"
                    class="text-left"
                    style="width: 25%"
                  >
                    HR secondary referent
                  </th>
                  <th
                    v-if="$route.params.typeRef == 'subGroupFunctions'"
                    class="text-left"
                    style="width: 50%"
                  >
                    Group function
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in listRefs"
                  :key="item.code"
                  @click="updateRef(item)"
                >
                  <td>{{ item.code }}</td>
                  <td>{{ item.label }}</td>
                  <td v-if="$route.params.typeRef == 'companies'">
                    {{ item.hrReferentDto.firstName }}
                    {{ item.hrReferentDto.lastName }}
                  </td>
                  <td v-if="$route.params.typeRef == 'companies'">
                    {{ item.hrSecondaryReferentDto.firstName }}
                    {{ item.hrSecondaryReferentDto.lastName }}
                  </td>
                  <td v-if="$route.params.typeRef == 'subGroupFunctions'">
                    {{ item.refGroupFunctionDto.code }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<style>
.margin-top {
  margin-top: 10px;
}

.no-margin {
  margin: 0 !important;
}

.card {
  height: 100vh !important;
}
</style>

<script>
import { mapGetters } from "vuex";
export default {
  name: "RefView",
  data() {
    return {
      roleParam: this.$route.query.role,
      findByName: "",
      listRefs: [],
      snackbar: false,
      snackBarText: "",
      snackBarColor: "",
      snackBarTimeout: 2000,
    };
  },
  computed: {
    ...mapGetters({
      userRoles: "auth/userRoles",
      perimeterAdmin: "auth/perimeterAdmin",
    }),
  },
  mounted: function() {
    this.loadRef();
    if (this.$route.query.add == "ok") {
      this.snackbar = true;
      this.snackBarText = "Saved successfully";
      this.snackBarColor = "success";
      var typeRef = this.$route.params.typeRef;
      this.$router.push("/refview/" + typeRef);
    }
  },
  methods: {
    hasRoleSuperAdmin: function() {
      if (this.userRoles && this.perimeterAdmin == "all") {
        var userHasRole = false;
        this.userRoles.forEach(function(currentRole) {
          if (currentRole === "ROLE_ADMIN") {
            userHasRole = true;
          }
        });
        return userHasRole;
      }
    },
    loadRef: function() {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      fetch(
        process.env.VUE_APP_ROOT_API_PATH +
          "api/ref/" +
          this.$route.params.typeRef,
        {
          method: "GET",
          credentials: "include",
          headers: myHeaders,
        }
      )
        .then((response) => {
          if (response.status == "200" || response.status == "201") {
            this.message =
              "If your e-mail address is correct and known by the application,";
            this.message +=
              " an e-mail has been sent with insctructions to reset your password";
            this.messageType = "success";
            return response.json();
          } else {
            this.message = "An error happened, please try again later";
            this.messageType = "error";
          }
          this.showMessage = true;
        })
        .then((json) => {
          this.listRefs = json.data;
        })
        .catch(() => {
          this.message = "An error occurs, please try again later";
          this.messageType = "error";
          this.showMessage = true;
        });
    },
    addNew: function() {
      this.$router.push("/refadd/" + this.$route.params.typeRef);
    },
    updateRef: function(item) {
      var str = this.$route.params.typeRef;
      var newStr = "";
      if (str == "companies") {
        newStr = "company";
      } else if (str == "countries") {
        newStr = "country";
      } else {
        newStr = str.substring(0, str.length - 1);
      }
      this.$router.push({
        path: "/refupdate?typeRef=" + newStr + "&code=" + item.code,
      });
    },
  },
};
</script>
